/*
 * @fileOverView FeaturedCarousel component definition
 */

import Vue from 'vue';
import 'slick-carousel';

/**
 * A reference to the selectors used in this view
 *
 * @property SELECTORS
 * @type {Object}
 * @private
 */
const SELECTORS = {
  'ARROW_NEXT': '.js-carouselNavigation-arrow_next',
  'ARROW_PREV': '.js-carouselNavigation-arrow_prev',
  'COUNT_CURRENT': '.js-carouselNavigation-count-current',
  'COUNT_TOTAL': '.js-carouselNavigation-count-total',
  'NAV_BUTTON': '.js-featuredCarousel-nav-button'
};

/**
 * [FeaturedCarousel Vue]
 * @type {class}
 */
Vue.component('featured-carousel-vue', {
  data: function() {
    return {
      activeSlide: 0
    }
  },

  mounted() {
    const $items = $(this.$refs.items);

    const itemCarousel = $items.slick({
      infinite: false,
      nextArrow: $(this.$el).find(SELECTORS.ARROW_NEXT),
      prevArrow: $(this.$el).find(SELECTORS.ARROW_PREV),
      speed: 500,
      touchThreshold: 10
    });

    $(this.$el).find(SELECTORS.NAV_BUTTON).on('click', function () {
      $items.slick('slickGoTo', $(this).parent().index());
    });

    // Handling the counter (CURRENT/TOTAL).
    $(this.$el).find(SELECTORS.COUNT_CURRENT).text(itemCarousel[0].slick.currentSlide + 1);
    $(this.$el).find(SELECTORS.COUNT_TOTAL).text(itemCarousel[0].slick.slideCount);

    // Allows nav items to stay in sync with main item slide changes.
    $items.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      $(this.$el).find(SELECTORS.COUNT_CURRENT).text(nextSlide + 1);
      this.activeSlide = nextSlide;
    });
  }
})
